import { useState } from "react";
import { Login as LoginIcon } from "@mui/icons-material";
import { Button } from "@mui/material";

import { startSignIn } from "../../../authentication/shared/start-sign-in";

interface SignInButtonProps {
  label?: string;
  /** Куда вернуть после входа; небезопасный адрес заменяется главной страницей. */
  returnUrl?: string | null;
}

/** Явный вход через IMS. После нажатия блокируется: браузер уже уходит на IMS. */
export const SignInButton = ({
  label = "Войти снова",
  returnUrl,
}: SignInButtonProps): JSX.Element => {
  const [isRedirecting, setRedirecting] = useState(false);

  const handleClick = () => {
    setRedirecting(true);
    startSignIn(returnUrl);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<LoginIcon />}
      disabled={isRedirecting}
      onClick={handleClick}
    >
      {label}
    </Button>
  );
};
